module.exports = __webpack_public_path__ + "static/media/ic_logout.cd76111e.svg";